import React, { Component } from 'react';
import { DownloadButton, PaddedSection } from '../../atoms';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} fileName
 *
 * @augments {Component<Props>}
 */
export default class DownloadBrochure extends Component {
	render () {
		const { buttonLabel, fileName } = this.props;

		const href = require(`../../../assets/files/${fileName}`);
		return (
			<PaddedSection className='DownloadBrochure'>
				<DownloadButton
					className={'Button Button-link'}
					href={href}
					download={true}
					buttonLabel={buttonLabel}
				/>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/DownloadBrochure/DownloadBrochure.js